// The logo of an online payment provider button (Payments.js).
//
// Paytrail's own providers come with `svg`, ePassi & co. with `icon`. The Paytrail benefit
// providers (Wolt, Zevoy, Edenred - kumpula/PAYTRAIL_BENEFITS_BACKEND_CHANGES.md) are listed with an
// empty `icon` until the merchant account brings logos, so a bundled logo stands in where Kumpula has
// one. null means "no logo": the button shows the provider's name instead of a broken image.

const BUNDLED_LOGOS = {
  edenred: '/imgs/edenred_logo.svg',
}

export const providerLogo = (provider, publicUrl = '') => {
  if (!provider) return null
  if (provider.svg) return provider.svg
  if (provider.icon) return provider.icon
  const bundled = provider.gateway === 'paytrail-benefits' ? BUNDLED_LOGOS[provider.id] : null
  return bundled ? (publicUrl || '') + bundled : null
}
